(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    if (!root || root.dataset.clpInitialized === 'true') return;
    root.dataset.clpInitialized = 'true';

    const slides = [...root.querySelectorAll('[data-clp-slide]')];
    const viewport = root.querySelector('[data-clp-viewport]');
    const dots = [...root.querySelectorAll('[data-clp-dot]')];
    const duration = Math.max(5000, Number(root.dataset.clpDuration) || 7000);
    let index = 0;
    let timer;
    let inView = true;
    let hovering = false;
    let focusHold = false;
    let userPaused = false;
    let lastPointerAt = 0;
    let gesture = null;
    let suppressClick = false;

    if (slides.length <= 1) root.classList.add('has-one-slide');

    function show(next, manual = false) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, current) => {
        const active = current === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a').forEach((link) => { link.tabIndex = active ? 0 : -1; });
      });
      dots.forEach((dot, current) => {
        const active = current === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (viewport) viewport.setAttribute('aria-live', manual ? 'polite' : 'off');
    }

    function canRotate() {
      return slides.length > 1 && !reducedMotion.matches && !document.hidden && inView && !hovering && !focusHold && !userPaused;
    }

    function syncTimer() {
      window.clearTimeout(timer);
      const running = canRotate();
      root.classList.toggle('is-paused', !running);
      dots.forEach((dot, current) => {
        const active = current === index;
        const label = active
          ? (userPaused ? 'Reanudar anuncios' : 'Pausar anuncios')
          : `Mostrar anuncio ${current + 1} de ${slides.length}`;
        dot.setAttribute('aria-label', label);
        dot.title = label;
        if (active && userPaused) dot.setAttribute('aria-pressed', 'true');
        else dot.removeAttribute('aria-pressed');
      });
      if (viewport && running) viewport.setAttribute('aria-live', 'off');
      if (running) {
        timer = window.setTimeout(() => {
          show(index + 1);
          syncTimer();
        }, duration);
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const next = Number(dot.dataset.clpDot);
        if (next === index) userPaused = !userPaused;
        else {
          userPaused = false;
          show(next, true);
        }
        syncTimer();
      });
    });

    viewport?.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      lastPointerAt = Date.now();
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    viewport?.addEventListener('pointerup', (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) < 38 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
      suppressClick = true;
      userPaused = false;
      show(index + (dx < 0 ? 1 : -1), true);
      syncTimer();
      window.setTimeout(() => { suppressClick = false; }, 0);
    });
    viewport?.addEventListener('pointercancel', () => { gesture = null; });
    viewport?.addEventListener('dragstart', (event) => { event.preventDefault(); });
    viewport?.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    root.addEventListener('mouseenter', () => { hovering = true; syncTimer(); });
    root.addEventListener('mouseleave', () => { hovering = false; syncTimer(); });
    root.addEventListener('focusin', () => {
      if (Date.now() - lastPointerAt < 500) return;
      focusHold = true;
      syncTimer();
    });
    root.addEventListener('focusout', (event) => {
      if (root.contains(event.relatedTarget)) return;
      focusHold = false;
      syncTimer();
    });
    document.addEventListener('visibilitychange', syncTimer);
    reducedMotion.addEventListener?.('change', syncTimer);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        syncTimer();
      }, { threshold: .1 }).observe(root);
    }

    show(0);
    syncTimer();
  }

  document.querySelectorAll('[data-clp]').forEach(initCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-clp]').forEach(initCarousel);
  });
})();
